import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import { Link } from "gatsby"
import Button from "@material-ui/core/Button"

import background from "../assets/images/Stone_Stairway_Hardscapes_Andreatta_Waterscapes_Grants_Pass_Oregon.jpg"

const useStyles = makeStyles(theme => ({
  background: {
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    height: "23.9375rem",
    width: "100%",
    position: "relative",
    [theme.breakpoints.down('md')]: {
      '@supports (-webkit-touch-callout: none)': {
        backgroundAttachment: 'scroll',
      },
    },
    [theme.breakpoints.down("xs")]: {
      backgroundAttachment: "scroll",
      height: "28.9375rem",
    },
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,.43)",
  },
  CTAHeader: {
    fontFamily: 'Work Sans, sans-serif',
    position: "relative",
    zIndex: 1,
    paddingTop: "3.6875rem",
    color: "#FFFFFF",
    fontSize: "2rem",
    // fontWeight: 800,
    fontWeight: 400,
    textTransform: "uppercase",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.875rem",
    },
  },
  CTABody: {
    fontFamily: 'Work Sans, sans-serif',
    position: "relative",
    zIndex: 1,
    color: "#FFFFFF",
    // fontWeight: 500,
    fontWeight: 300,
    fontSize: "1.25rem",
    // fontSize: "1.75rem",
    paddingTop: "1.875rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.35rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
    },
  },
  CTABtn: {
    marginTop: "2.75rem",
    marginLeft: "auto",
    marginRight: "auto",
    // backgroundColor: "#FFFFFF",
    color: "#FFFFFF",
    backgroundColor: theme.palette.secondary.main,
    // color: theme.palette.secondary.main,
    padding: ".35rem 1.85rem",
    textTransform: "capitalize",
    fontSize: ".925rem",
    fontWeight: 400,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    }
    // fontWeight: 800,
  },
}))

export default function CallToAction({ end }) {
  const classes = useStyles()

  return (
    <Grid
      container
      direction="row"
      style={{
        paddingTop: "3.21875em",
        paddingBottom: end ? undefined : "6.25em",
      }}
    >
      <Grid item xs={12} className={classes.background}>
        <div className={classes.overlay} />
        <Grid
          container
          direction="row"
          justifyContent="center"
          style={{ height: "100%", padding: "0 1em" }}
        >
          <Grid item xs={12}>
            <Typography
              align="center"
              variant="h5"
              className={classes.CTAHeader}
            >
              Ready to get started on your project?
            </Typography>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={8} lg={7} xl={6}>
                <Typography
                  align="center"
                  variant="h6"
                  className={classes.CTABody}
                >
                  {/* To request a consultation, contact us at 541-664-4511 or fill
                  out our online request form. A member of our team will contact
                  you to discuss your project and answer your questions. */}
                  To request a consultation, please fill out our online request
                  form. A member of our team will contact you to discuss your
                  project and answer your questions.
                </Typography>
              </Grid>
              <Grid container item xs={12} justifyContent="center">
                <Button
                  component={Link}
                  to="/contact/"
                  variant="contained"
                  className={classes.CTABtn}
                >
                  Get started
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
